/* global window */

window.dataLayer = window.dataLayer || [];

export const clubList = (clubs, currency) => {
  const items = clubs.map((p, index) => ({
    currency,
    item_name: p.title,
    item_id: p.slug,
    index
  }));

  const payload = {
    event: 'view_club_list',
    club: {
      items
    }
  };

  window.dataLayer.push(payload);
};

export const clubDetail = (club, currency) => {
  const items = [
    {
      currency,
      item_name: club.title,
      item_id: club.slug
    }
  ];

  const payload = {
    event: 'view_club_list',
    club: {
      items
    }
  };

  window.dataLayer.push(payload);
};

export const selectClub = (clubSignup, currency) => {
  const payload = {
    event: 'select_club',
    club: {
      items: [
        {
          currency,
          item_name: clubSignup.club.title,
          item_id: clubSignup.club.slug
        }
      ]
    }
  };
  window.dataLayer.push(payload);
};

export const clubSignupStep = (clubSignup, currency, step) => {
  const club = getClubPayload(clubSignup, currency);

  const payload = {
    event: step,
    club
  };
  window.dataLayer.push(payload);
};

export const clubPurchase = (clubSignup, currency) => {
  const club = getClubPayload(clubSignup, currency);

  club.transaction_id = clubSignup.clubMembershipId;

  const payload = {
    event: 'club_purchase',
    club
  };
  window.dataLayer.push(payload);
};

const getClubPayload = (clubSignup, currency) => {
  const items = [
    {
      currency,
      item_name: clubSignup.club.title,
      item_id: clubSignup.club.slug
    }
  ];

  const payload = {
    currency,
    payment_type: 'Credit Card',
    items
  };

  return payload;
};
